import Typography from "@mui/material/Typography";
import {
  Button,
  Grid,
  IconButton,
  TextField,
  LinearProgress,
  Card,
  CardContent,
  Stack,
  Divider,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import Box from "@mui/material/Box";
import { DataGrid, GridPagination } from "@mui/x-data-grid";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { User } from "../../../../../../app/slices/userSlice";
import {
  Wallet,
  setRecivedCashDialog,
  setTransferDialog,
  setTopupDialog,
  setWithdrawDialog,
  setClearanceDialog,
  setWithdrawPosDialog,
  setCorrectBalanceDialog,
  setTransactionsSearchBody,
} from "../../../../../../app/slices/walletSlice";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { HiOutlineArrowsRightLeft } from "react-icons/hi2";
import {
  MobileAction,
  MobileBadge,
  MobileEmpty,
  MobileListItem,
  MobileListShell,
  MobilePagination,
  TONE,
} from "../../../../../../components/MobileList";
import { MdOutlineClear } from "react-icons/md";
import TransactionForm from "../../form";
import DateRangepicker from "../../../../../../helpers/dateRangePicker";
import { SelectTransactionTypes } from "../../../../../../components/Selectors/SelectTransactionTypes";
import { BiCalculator, BiInfoCircle, BiLinkExternal } from "react-icons/bi";
import UserInfoCard from "../../userInfoCard";
import FinancialInfoCard from "../../financialInfoCard";
import { useTheme } from "@emotion/react";
import Permission from "../../../../../../components/userPermission/userPermission";
import { BsFillFileEarmarkExcelFill } from "react-icons/bs";

const TransactionTable = () => {
  const { user_id } = useParams();

  const dispatch = useDispatch();
  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [pageSize, setPageSize] = useState(15);
  const [currentPage, setCurrentPage] = useState(0);
  const [search, setSearch] = useState({
    search: "",
    order_id: "",
    user_type: null,
    date: "",
    type: null,
    startDate: dayjs().format("2023-01-01"),
    endDate: dayjs().format("YYYY-MM-DD"),
    skip: 0,
    transaction_number: "",
  });
  const _Loading = useSelector((state) => state.wallet.wallet.loading);
  const transactionsSearchBody = useSelector(
    (state) => state.wallet.transactionsSearchBody,
  );
  const _LoadingMonthlyRep = useSelector(
    (state) => state.wallet.monthlyRep.loading,
  );
  const _Transactions = useSelector((state) => state.wallet.transactions);
  const user = useSelector((state) => state.user.user.form);
  const _Wallet = useSelector((state) => state.wallet);
  const _TransactionTypes = useSelector(
    (state) => state.wallet.transactionType,
  );

  const checkBalanceDifferenceDate = (transaction_id) => {
    dispatch(
      Wallet.checkBalanceDifferenceDate({
        user_id: user.id,
        transaction_id: transaction_id,
      }),
    ).then((res) => {});
  };

  const openOrderInNewTab = (orderId) => {
    // Open the orders page filtered by this order id. Widen the date range to
    // cover the whole year (from the start of the year to today) because the
    // order may be older than the default (current month) range.
    window.open(`/app/orders?order_id=${orderId}&full_year=1`, "_blank");
  };

  const columns = [
    {
      field: "number",
      headerName: "رقم المناقلة",
      flex: 1,
    },
    {
      field: "order_id",
      headerName: "رقم الطلب",
      flex: 1,
    },
    {
      field: "amount",
      headerName: "القيمة (IQD)",
      flex: 1,
      renderCell: (params) => {
        return <Typography>{params.row.amount?.toLocaleString()}</Typography>;
      },
    },
    {
      field: "by_user_name",
      headerName: "بواسطة",
      flex: 1,
      renderCell: (params) => {
        return <Typography>{params.row.by_user_name}</Typography>;
      },
    },
    {
      field: "from_user_name",
      headerName: "من المحفظة",
      flex: 1,
    },
    {
      field: "to_user_name",
      headerName: " الى المحفظة",
      flex: 1,
    },
    {
      field: "from_user",
      headerName: "حساب المرسل (IQD)",
      flex: 1,
      renderCell: (params) => {
        return (
          <Stack
            direction="column"
            spacing={1}
            justifyContent="center"
            alignItems="center"
          >
            <Typography>
              الرصيد: {params.row.from_current_balance?.toLocaleString()}
            </Typography>
            <Typography>
              الديون :{params.row.from_current_debt?.toLocaleString()}
            </Typography>
          </Stack>
        );
      },
    },
    {
      field: "to_user",
      headerName: "حساب المستلم (IQD)",
      flex: 1,
      renderCell: (params) => {
        return (
          <Stack
            direction="column"
            spacing={1}
            justifyContent="center"
            alignItems="center"
          >
            <Typography>
              الرصيد: {params.row.to_current_balance?.toLocaleString()}
            </Typography>
            <Typography>
              الديون :{params.row.to_current_debt?.toLocaleString()}
            </Typography>
          </Stack>
        );
      },
    },
    {
      field: "created_at",
      headerName: "تاريخ العملية",
      flex: 1,
      renderCell: (params) => {
        return (
          <Typography>
            {dayjs(params.row.created_at).format("HH:mm:ss / YYYY-MM-DD ")}
          </Typography>
        );
      },
    },
    {
      field: "type",
      headerName: "نوع العملية",
      flex: 1,
      renderCell: (params) => {
        return (
          <Stack>
            <Stack direction={"row"} spacing={1}>
              <Typography>{params.row.type}</Typography>
              {params.row.note && (
                <Tooltip title={params.row.note}>
                  <IconButton size="small">
                    <BiInfoCircle />
                  </IconButton>
                </Tooltip>
              )}
            </Stack>
            <Stack direction={"row"}>
              <IconButton
                size="small"
                onClick={() => checkBalanceDifferenceDate(params.row.id)}
              >
                <BiCalculator />
              </IconButton>
              {params.row.type === "شراء ارصدة" && params.row.order_id && (
                <Tooltip title="عرض الطلب">
                  <IconButton
                    size="small"
                    onClick={() => openOrderInNewTab(params.row.order_id)}
                  >
                    <BiLinkExternal />
                  </IconButton>
                </Tooltip>
              )}
              {/* <Typography>{difference}</Typography> */}
            </Stack>
          </Stack>
        );
      },
    },
  ];

  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(Wallet.getAllTransaction(transactionsSearchBody));
    }, 500);
    return () => clearTimeout(timeout);
  }, [dispatch, transactionsSearchBody]);

  useEffect(() => {
    dispatch(
      setTransactionsSearchBody({
        user_id: user_id,
        order_id: search.order_id,
        date: search.date,
        skip: currentPage * pageSize,
        take: pageSize,
        type: search.type ? JSON.stringify(search.type) : "",
        start_date: search.startDate,
        end_date: search.endDate,
        transaction_number: search.transaction_number,
        search: search.search,
      }),
    );
  }, [currentPage, dispatch, pageSize, search, user_id]);

  useEffect(() => {
    dispatch(User.getByIdData(user_id));
  }, [user_id, _Wallet.reload, dispatch]);

  function CustomFooter() {
    return (
      <Stack
        direction="row"
        sx={{ justifyContent: "space-between", alignItems: "center" }}
      >
        <Typography color="primary" sx={{ marginX: 2 }}>
          القيمة الكلية : {_Transactions.total_amount.toLocaleString()} (IQD)
        </Typography>
        <GridPagination />
      </Stack>
    );
  }

  return (
    <Card>
      <CardContent>
        <Box>
          <TransactionForm />
        </Box>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item xs={12}>
            <Grid container spacing={3} sx={{ mb: 2 }}>
              {/* User Info Card */}
              <Grid item xs={12} md={4}>
                <UserInfoCard />
              </Grid>

              {/* Financial Info Card */}
              <Grid item xs={12} md={4}>
                <FinancialInfoCard />
              </Grid>

              {/* Actions Card */}
              <Grid item xs={12} md={4}>
                <Card
                  sx={{
                    background:
                      "linear-gradient(135deg, #fff3e0 0%, #ffcc02 100%)",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <CardContent>
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: "bold", color: "#f57c00", mb: 2 }}
                    >
                      العمليات
                    </Typography>
                    <Grid container spacing={1}>
                      <Grid item xs={6}>
                        <Permission permission="wallet_edit">
                          <Button
                            size="small"
                            variant="contained"
                            fullWidth
                            onClick={() =>
                              !user.is_representative
                                ? dispatch(setRecivedCashDialog())
                                : dispatch(setClearanceDialog())
                            }
                          >
                            تسديد ديون
                          </Button>
                        </Permission>
                      </Grid>
                      <Grid item xs={6}>
                        <Permission permission="wallet_edit">
                          <Button
                            size="small"
                            variant="contained"
                            fullWidth
                            onClick={() => dispatch(setTransferDialog())}
                          >
                            مناقلة رصيد
                          </Button>
                        </Permission>
                      </Grid>
                      <Grid item xs={6}>
                        <Permission permission="wallet_edit">
                          <Button
                            size="small"
                            variant="contained"
                            fullWidth
                            onClick={() => dispatch(setWithdrawPosDialog())}
                          >
                            سحب رصيد
                          </Button>
                        </Permission>
                      </Grid>
                      <Permission permission="wallet_edit">
                        <Grid item xs={6}>
                          <Button
                            size="small"
                            variant="contained"
                            fullWidth
                            onClick={() => dispatch(setCorrectBalanceDialog())}
                          >
                            تعديل العملية
                          </Button>
                        </Grid>
                      </Permission>
                      <Grid item xs={6}>
                        <Permission permission="wallet_edit">
                          <Button
                            size="small"
                            variant="contained"
                            fullWidth
                            onClick={() => dispatch(setWithdrawDialog())}
                          >
                            سحب من المندوب
                          </Button>
                        </Permission>
                      </Grid>
                      <Grid item xs={6}>
                        <Permission permission="wallet_edit">
                          <Button
                            size="small"
                            variant="contained"
                            fullWidth
                            onClick={() => dispatch(setTopupDialog())}
                          >
                            اضافة رصيد
                          </Button>
                        </Permission>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            {_LoadingMonthlyRep && <LinearProgress />}
            <Divider sx={{ my: 2 }} />
          </Grid>
          <Grid item xs={12} md={2}>
            <TextField
              size="small"
              value={search.search}
              onChange={(e) => {
                setSearch({
                  ...search,
                  search: e.target.value,
                });
              }}
              label="رقم نقطة، اسم نقطة بيع او رقم هاتف"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <TextField
              size="small"
              value={search.transaction_number}
              onChange={(e) => {
                setSearch({
                  ...search,
                  transaction_number: e.target.value,
                });
              }}
              label="بحث عن رقم المناقلة"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <TextField
              size="small"
              value={search.order_id}
              onChange={(e) => {
                setSearch({
                  ...search,
                  order_id: e.target.value,
                });
              }}
              label="بحث عن رقم الطلب"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <SelectTransactionTypes
              multiple
              onChange={(event, value) => {
                var ids = value.map((x) => x.key);
                setSearch({
                  ...search,
                  type: value ? ids : null,
                });
              }}
              value={
                _TransactionTypes?.filter((x) =>
                  search.type?.includes(x.key),
                ) ?? []
              }
              // value={search.type}
              // onChange={(e, newValue) => {
              //   setSearch({
              //     ...search,
              //     type: newValue ? newValue : null
              //   })
              // }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <DateRangepicker
              startDate={search.startDate}
              endDate={search.endDate}
              handleOnChange={(searchDate) => {
                const updatedFilter = {
                  from: dayjs(searchDate[0].startDate).format("YYYY-MM-DD"),
                  to: dayjs(searchDate[0].endDate).format("YYYY-MM-DD"),
                };
                if (
                  updatedFilter.from !== searchDate.startDate ||
                  updatedFilter.to !== searchDate.endDate
                ) {
                  setSearch({
                    ...search,
                    startDate: dayjs(searchDate[0].startDate).format(
                      "YYYY-MM-DD",
                    ),
                    endDate: dayjs(searchDate[0].endDate).format("YYYY-MM-DD"),
                  });
                }
              }}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <Stack direction="row" spacing={0} sx={{ alignItems: "center" }}>
              <Tooltip title="تصدير ملف اكسل">
                <IconButton
                  onClick={() => {
                    dispatch(Wallet.exportExcel(transactionsSearchBody));
                  }}
                >
                  <BsFillFileEarmarkExcelFill />
                </IconButton>
              </Tooltip>
              <Tooltip title="الغاء الفلتر">
                <IconButton
                  onClick={() => {
                    setSearch({
                      search: "",
                      order_id: "",
                      user_type: null,
                      date: "",
                      type: null,
                      startDate: dayjs().format("2023-01-01"),
                      endDate: dayjs().format("YYYY-MM-DD"),
                      skip: 0,
                      take: 15,
                      transaction_number: "",
                    });
                    setPageSize(15);
                    setCurrentPage(0);
                  }}
                >
                  <MdOutlineClear />
                </IconButton>
              </Tooltip>
            </Stack>
          </Grid>
          {smallScreen ? (
            <Grid item xs={12}>
              <MobileListShell loading={_Loading}>
                {_Transactions?.data?.length > 0 ? (
                  <>
                    {_Transactions.data.map((row, index) => (
                      <MobileListItem
                        key={index}
                        avatar={<HiOutlineArrowsRightLeft />}
                        title={`مناقلة #${row.number}`}
                        subtitle={dayjs(row.created_at).format(
                          "YYYY-MM-DD · hh:mm a"
                        )}
                        badge={
                          row.type ? <MobileBadge label={row.type} /> : null
                        }
                        highlight={{
                          label: "القيمة",
                          value: (row.amount ?? 0).toLocaleString(),
                          unit: "IQD",
                        }}
                        fields={[
                          { label: "رقم الطلب", value: row.order_id },
                          { label: "من المحفظة", value: row.from_user_name },
                          { label: "الى المحفظة", value: row.to_user_name },
                          {
                            label: "رصيد المرسل",
                            value: row.from_current_balance?.toLocaleString(),
                          },
                          {
                            label: "ديون المرسل",
                            value: row.from_current_debt?.toLocaleString(),
                          },
                          {
                            label: "رصيد المستلم",
                            value: row.to_current_balance?.toLocaleString(),
                          },
                          {
                            label: "ديون المستلم",
                            value: row.to_current_debt?.toLocaleString(),
                          },
                        ]}
                        note={row.note}
                        actions={
                          <>
                            <MobileAction
                              title="فرق الرصيد"
                              tone={TONE.neutral}
                              icon={<BiCalculator />}
                              onClick={() => checkBalanceDifferenceDate(row.id)}
                            />
                            {row.type === "شراء ارصدة" && row.order_id && (
                              <MobileAction
                                title="عرض الطلب"
                                icon={<BiLinkExternal />}
                                onClick={() => openOrderInNewTab(row.order_id)}
                              />
                            )}
                          </>
                        }
                      />
                    ))}
                    <MobilePagination
                      count={_Transactions.total ?? 0}
                      rowsPerPage={pageSize}
                      page={currentPage}
                      onPageChange={(e, newPage) => setCurrentPage(newPage)}
                      rowsPerPageOptions={[15, 25, 50, 100]}
                      onRowsPerPageChange={(event) => {
                        const newRowsPerPage = parseInt(event.target.value, 10);
                        setPageSize(newRowsPerPage);
                      }}
                    />
                  </>
                ) : (
                  <MobileEmpty />
                )}
              </MobileListShell>
            </Grid>
          ) : (
            <Grid item xs={12}>
              <Box sx={{ height: "45vh", width: "100%" }}>
                <DataGrid
                  rows={_Transactions.data}
                  columns={columns}
                  pageSize={pageSize}
                  page={currentPage}
                  rowCount={_Transactions.total}
                  loading={_Loading}
                  rowHeight={65}
                  pagination
                  paginationMode="server"
                  selectionModel={[]}
                  onPageChange={(newPage) => {
                    setCurrentPage(newPage);
                  }}
                  rowsPerPageOptions={[15, 25, 50, 100]}
                  onPageSizeChange={(newPageSize) => {
                    setPageSize(newPageSize);
                  }}
                  components={{
                    LoadingOverlay: LinearProgress,
                    Footer: CustomFooter,
                  }}
                />
              </Box>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default TransactionTable;
